/* WFY custom collection filter — replaces Globo.
   Reads data-wfy-t (tags) + data-wfy-c (collection handles) off each grid card,
   and filter options marked .wfy-filter[data-wfy-type="c|t"][data-wfy-val].
   Behaviour: every ticked option ANDs (narrows); counts update to the current
   selection; options that would yield zero results are hidden. "All Meals" (or any
   [data-wfy-reset]) clears the selection. */
(function () {
  'use strict';

  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function items() { return qa('#collection > li.product-card'); }
  function filters() { return qa('.wfy-filter'); }

  // does a card carry a given collection/tag value?
  function cardHas(card, type, val) {
    var attr = type === 'c' ? 'data-wfy-c' : 'data-wfy-t';
    var raw = card.getAttribute(attr) || '';
    // exact-token match on the comma list
    return (',' + raw + ',').indexOf(',' + val + ',') !== -1;
  }

  // card matches ALL of the given [{type,val}] selections (AND)
  function cardMatches(card, sel) {
    for (var i = 0; i < sel.length; i++) {
      if (!cardHas(card, sel[i].type, sel[i].val)) return false;
    }
    return true;
  }

  function currentSelection() {
    return filters()
      .filter(function (f) { return f.checked; })
      .map(function (f) {
        return { type: f.getAttribute('data-wfy-type'), val: f.getAttribute('data-wfy-val'), el: f };
      });
  }

  // the count element + the option wrapper (to hide) for a given filter input
  function countEl(f) {
    return (f.closest('label') || f.parentNode || document).querySelector('.wfy-count');
  }
  function optionEl(f) {
    return f.closest('.wfy-filter-option') || f.closest('li') || f.closest('label') || f.parentNode;
  }

  function render() {
    var cards = items();
    var opts = filters();
    var sel = currentSelection();

    // 1) show/hide cards: visible iff it matches every selected filter
    cards.forEach(function (card) {
      card.style.display = cardMatches(card, sel) ? '' : 'none';
    });

    // 2) per-option count = cards matching (current selection + this option);
    //    hide any unselected option whose count is 0.
    opts.forEach(function (f) {
      var type = f.getAttribute('data-wfy-type');
      var val = f.getAttribute('data-wfy-val');
      var isSelected = f.checked;
      var probe = isSelected ? sel : sel.concat([{ type: type, val: val }]);
      var count = 0;
      for (var i = 0; i < cards.length; i++) {
        if (cardMatches(cards[i], probe)) count++;
      }
      var c = countEl(f);
      if (c) c.textContent = '(' + count + ')';
      var opt = optionEl(f);
      if (opt) opt.style.display = (count === 0 && !isSelected) ? 'none' : '';
    });

    // 3) reflect selection count on the "Filter By" toggle if present
    var badge = document.querySelector('[data-wfy-selected-count]');
    if (badge) badge.textContent = sel.length ? '(' + sel.length + ')' : '';
  }

  function clearAll() {
    filters().forEach(function (f) { if (f.checked) f.checked = false; });
    render();
  }

  function onChange(e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-wfy-reset')) {
      e.preventDefault();
      clearAll();
      return;
    }
    if (t && t.classList && t.classList.contains('wfy-filter')) {
      render();
    }
  }

  function togglePanel(forceClose) {
    var btn = document.querySelector('.wfy-filter-toggle');
    var panel = document.getElementById('wfy-filter-panel');
    var backdrop = document.querySelector('.wfy-filter-backdrop');
    if (!btn || !panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    if (forceClose === true) { open = true; } // treat as "currently open" so we close it
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (open) {
      panel.setAttribute('hidden', '');
      if (backdrop) backdrop.setAttribute('hidden', '');
    } else {
      panel.removeAttribute('hidden');
      if (backdrop) backdrop.removeAttribute('hidden');
    }
  }

  // ---- Quantity stepper (self-contained; no theme rebuild, no global event firing) ----
  // Our card renders <span.wfy-qty> = [ − | typeable number box | + ] (product-item.liquid).
  // We wire the buttons + validate typing here, and show "Only N serves available." when the
  // customer hits the stock cap (the box's max = live inventory, rendered by Liquid).
  function qtyBounds(input) {
    var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min) || min < 1) min = 1;
    var maxA = input.getAttribute('max');
    var max = (maxA === null || maxA === '') ? Infinity : parseInt(maxA, 10); if (isNaN(max)) max = Infinity;
    var step = parseInt(input.getAttribute('step'), 10); if (isNaN(step) || step < 1) step = 1;
    return { min: min, max: max, step: step };
  }

  function announceCap(box, max) {
    var msg = box.querySelector('.wfy-qty-msg');
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'wfy-qty-msg';
      msg.setAttribute('role', 'status');
      box.appendChild(msg);
    }
    msg.textContent = 'Only ' + max + (max === 1 ? ' serve' : ' serves') + ' available.';
    box.classList.add('wfy-qty-capped');
    clearTimeout(box.__wfyMsgT);
    box.__wfyMsgT = setTimeout(function () { box.classList.remove('wfy-qty-capped'); }, 3000);
  }

  function syncBtns(box, input) {
    var b = qtyBounds(input), v = parseInt(input.value, 10); if (isNaN(v)) v = b.min;
    var dec = box.querySelector('.wfy-qty-dec'), inc = box.querySelector('.wfy-qty-inc');
    if (dec) dec.classList.toggle('wfy-qty-off', v <= b.min); // spans, not <button> — no :disabled
    if (inc) inc.classList.toggle('wfy-qty-off', v >= b.max);
  }

  function stepQty(box, input, dir) {
    var b = qtyBounds(input), v = parseInt(input.value, 10); if (isNaN(v)) v = b.min;
    var next = v + dir * b.step;
    if (next > b.max) { input.value = b.max; announceCap(box, b.max); }
    else if (next < b.min) { input.value = b.min; }
    else { input.value = next; }
    syncBtns(box, input); // update the +/- state directly; NO bubbling event, so we never nudge the cart apps
  }

  function wireQty() {
    qa('#collection [data-wfy-qty]').forEach(function (box) {
      if (box.__wfyQty) return; box.__wfyQty = true;
      var input = box.querySelector('.wfy-qty-input') || box.querySelector('input[name="quantity"]');
      if (!input) return;
      var dec = box.querySelector('.wfy-qty-dec'), inc = box.querySelector('.wfy-qty-inc');
      if (dec) dec.addEventListener('click', function () { stepQty(box, input, -1); });
      if (inc) inc.addEventListener('click', function () { stepQty(box, input, 1); });
      // Clamp DOWN in real time so an over-max value can NEVER be submitted. This prevents a racy
      // 422 on add (un-clamped value reaching /cart/add.js first), which was pushing the add down
      // the error path and suppressing the normal side-cart open / toast. Typing at or below max is
      // untouched; the full min+max clamp still runs on change (blur / Enter).
      input.addEventListener('input', function () {
        var b = qtyBounds(input), v = parseInt(input.value, 10);
        if (!isNaN(v) && v > b.max) { input.value = b.max; announceCap(box, b.max); }
        syncBtns(box, input);
      });
      // full clamp + explain on change (blur / Enter)
      input.addEventListener('change', function () {
        var b = qtyBounds(input), v = parseInt(input.value, 10);
        if (isNaN(v) || v < b.min) v = b.min;
        if (v > b.max) { v = b.max; announceCap(box, b.max); }
        input.value = v;
        syncBtns(box, input);
      });
      // Guard the Add button: if the customer already holds ALL available stock (cart-aware, below),
      // block the add — a further add would 422 "already sold out" and freeze the drawer. Capture
      // phase so we beat the theme's submit handler; preventDefault only, never a cart write.
      var addBtn = box.parentNode && box.parentNode.querySelector('.overlay-buy_button');
      if (addBtn && !addBtn.__wfyGuard) {
        addBtn.__wfyGuard = true;
        addBtn.addEventListener('click', function (e) {
          if (!box.classList.contains('wfy-qty-maxed')) return;
          e.preventDefault();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          announceMaxed(box);
        }, true);
      }
      syncBtns(box, input);
    });
  }

  function announceMaxed(box) {
    var msg = box.querySelector('.wfy-qty-msg');
    if (!msg) { msg = document.createElement('span'); msg.className = 'wfy-qty-msg'; msg.setAttribute('role', 'status'); box.appendChild(msg); }
    msg.textContent = 'That’s all we have available.';
    box.classList.add('wfy-qty-capped');
    clearTimeout(box.__wfyMsgT);
    box.__wfyMsgT = setTimeout(function () { box.classList.remove('wfy-qty-capped'); }, 3000);
  }

  // ---- Cart-aware stock cap (restores what Globo's getCollectionStockInfo did, custom.js:2796) ----
  // Each card renders data-stock = live inventory (tracked "deny" variants only). A customer must never
  // be able to add more than (stock − what's already in their cart), or Shopify/Pickeasy chokes with a
  // "sold out" 422 that freezes the drawer. We read /cart.js (READ-ONLY — no writes, no dispatched
  // events) and set each stepper's max to the remaining allowance; if they already hold it all, the
  // card is flagged 'maxed' and the Add guard above blocks it.
  function fetchCartQtys() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var map = {};
        if (cart && cart.items) cart.items.forEach(function (it) {
          var k = String(it.variant_id); map[k] = (map[k] || 0) + it.quantity;
        });
        return map;
      })
      .catch(function () { return {}; });
  }

  function variantIdOf(box) {
    var form = box.closest('form'); if (!form) return '';
    var sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    var hid = form.querySelector('input[name="id"]');
    return hid ? hid.value : '';
  }

  function applyCartAwareMax(cartMap) {
    qa('#collection [data-wfy-qty]').forEach(function (box) {
      var input = box.querySelector('.wfy-qty-input') || box.querySelector('input[name="quantity"]');
      if (!input) return;
      var stockA = input.getAttribute('data-stock');
      if (stockA === null || stockA === '') return;         // untracked / rule-limited — leave max as rendered
      var stock = parseInt(stockA, 10); if (isNaN(stock)) return;
      var vid = variantIdOf(box);
      var inCart = (vid && cartMap[vid]) || 0;
      var eff = stock - inCart; if (eff < 0) eff = 0;
      input.setAttribute('max', String(eff));
      var maxed = eff < 1;
      box.classList.toggle('wfy-qty-maxed', maxed);
      var v = parseInt(input.value, 10);
      if (!isNaN(v) && !maxed && v > eff) input.value = eff;  // clamp the current number down if now over allowance
      syncBtns(box, input);
    });
  }

  function refreshStock() { fetchCartQtys().then(applyCartAwareMax); }

  // After the theme's OWN native add-to-cart finishes, put every card's number back to 1 —
  // a quiet visual confirmation the add worked. We listen for the theme's native cart signal
  // ('wfy:cart-dom-updated', fired from custom-async.js:5717 after the cart re-renders) and only
  // touch the displayed number. No stock / AJAX / drawer logic here — the theme already did all
  // of that; this is the small piece the old Globo binder tacked on at custom.js:2925.
  function resetQtys() {
    // Put each card's number back to 1 by DIRECT assignment only — deliberately NO dispatched
    // input/change events. This runs on wfy:cart-dom-updated, i.e. DURING a cart operation, and a
    // bubbling event here was a plausible trigger for a second, conflicting cart write
    // (Pickeasy/Bundler) → the 422 / freeze. Setting .value updates the visible number; syncBtns
    // updates the +/- state. Nothing leaves this stepper.
    qa('#collection [data-wfy-qty]').forEach(function (box) {
      var inp = box.querySelector('.wfy-qty-input') || box.querySelector('input[name="quantity"]');
      if (!inp || inp.value === '1') return;
      inp.value = '1';
      syncBtns(box, inp);
    });
  }

  function init() {
    if (!document.getElementById('collection')) return; // not a collection grid
    if (!filters().length) return;                        // filter UI not present
    document.addEventListener('change', onChange, false);
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-wfy-toggle]');
      if (toggle) { e.preventDefault(); togglePanel(); return; }
      var r = e.target.closest && e.target.closest('[data-wfy-reset]');
      if (r) { e.preventDefault(); clearAll(); }
    }, false);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var b = document.querySelector('.wfy-filter-toggle');
      if (b && b.getAttribute('aria-expanded') === 'true') togglePanel(true);
    }, false);
    // TEMPORARILY OFF while we isolate a cart 422/freeze regression. This was our ONLY hook into the
    // cart flow (it reset a card's number to 1 after adding). With it disabled, this script does
    // absolutely nothing during add/remove/update — the stepper only reacts to clicks/typing on the
    // cards. If the freeze stops with this off, this listener was the cause and we re-add it safely.
    // document.addEventListener('wfy:cart-dom-updated', resetQtys, false);
    render();              // initial pass (counts + any pre-checked state)
    wireQty();             // wire our own −/+ steppers (predictable; typeable; shows the stock cap)
    window.addEventListener('load', wireQty, false); // belt-and-braces if any card mounts late
    refreshStock();        // cart-aware stock caps (read-only /cart.js)
    // Re-cap after any cart change. READ-ONLY (a /cart.js GET + attribute updates) — this does NOT
    // write to the cart or dispatch events, so it can't cause the Pickeasy 422/freeze the way a
    // cart-write hook could. (The old resetQtys write-hook stays disabled above.)
    document.addEventListener('wfy:cart-dom-updated', refreshStock, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, false);
  } else {
    init();
  }
})();
